import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
export default {
  name: 'Trend',
  props: {
    term: {
      type: String,
      required: true
    },
    target: {
      type: Number,
      required: false,
      default: 0
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    isIncrease: {
      type: Boolean,
      required: false,
      default: null
    },
    percent: {
      type: Number,
      required: false,
      default: null
    },
    scale: {
      type: Number,
      required: false,
      default: 2
    }
  },
  data: function data() {
    return {
      trend: this.isIncrease ? 'up' : 'down',
      rate: this.percent
    };
  },
  created: function created() {
    this.trend = this.caulateTrend();
    this.rate = this.caulateRate();
  },
  methods: {
    caulateRate: function caulateRate() {
      return (this.percent === null ? Math.abs(this.value - this.target) * 100 / this.target : this.percent).toFixed(this.scale);
    },
    caulateTrend: function caulateTrend() {
      var isIncrease = this.isIncrease === null ? this.value >= this.target : this.isIncrease;
      return isIncrease ? 'up' : 'down';
    }
  }
};